import Vue from "vue";
import Moment from "moment";
import VuemomentJS from "vue-momentjs";

const state = {
  countries: [],
  totalCountries: 0
};

const getters = {};

const actions = {
  LOAD_COUNTRIES: async function({ commit, rootState }, payLoad) {
    return await Vue.prototype.$axios
      .get("/countries?from=" + payLoad.from + "&limit=" + payLoad.to)
      .then(
        response => {
          commit("SET_COUNTRIES", response.data.countries);
          commit("SET_TOTAL_COUNTRIES", response.data.meta.total);
          return response;
        },
        err => {
          throw new Error(err);
        }
      );
  }
};

const mutations = {
  SET_COUNTRIES: (state, countries) => {
    state.countries = countries;
  },
  SET_TOTAL_COUNTRIES: (state, total) => {
    state.totalCountries = total;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
